export default "__VITE_ASSET__0a765333__"